// extracted by mini-css-extract-plugin
export default {"tag":"_18mdrPRPPQ1ar4x2RCu0vk","removeBtn":"PtsTrTR_hLL7Rp6XEwrW3"};